import Rails from '@rails/ujs'
import * as ActiveStorage from '@rails/activestorage'
import "@hotwired/turbo-rails"
import '../utils/turbo_ujs_compat'
import '../utils/modal_link'
import '../utils/turbo_stream_actions'
import { Application } from "@hotwired/stimulus";

import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers";

const application = Application.start();

const context = require.context("../controllers/nova", true, /\.js$/);
application.load(definitionsFromContext(context));

import Trix from 'trix'
import '../trix/trix_config'
import '@rails/actiontext'

window.Trix = Trix

Rails.start()
ActiveStorage.start()

window.Stimulus = application;
console.log("Nova application works properly");
